import { render, staticRenderFns } from "./errorModal.vue?vue&type=template&id=86827a22&scoped=true&"
import script from "./errorModal.vue?vue&type=script&lang=js&"
export * from "./errorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86827a22",
  null
  
)

export default component.exports